import script from "./ProductRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRibbon.vue?vue&type=script&setup=true&lang=js"

import "./ProductRibbon.vue?vue&type=style&index=0&id=f45ba3a2&scoped=true&lang=css"
import "./ProductRibbon.vue?vue&type=style&index=1&id=f45ba3a2&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f45ba3a2"]])

export default __exports__